import { DecimalPipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ModalController, Platform } from "ionic-angular";
import moment from "moment";
import { Observable } from "rxjs/Observable";
import { ISubscription } from "rxjs/Subscription";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";

const dateTimeFormat = "MM/DD/YYYY HH:mm";

/**
 * Generated class for the AddendumAttestationListCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "add-att-list-card",
  templateUrl: "add-att-list-card.html",
})
export class AddendumAttestationListCardComponent implements OnInit, OnDestroy {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;

  id: string;
  name: string;
  componentId: string;
  label: string;
  access: string;
  tooltip: object;
  colHeaders: string[];
  conditionalFormatting: object;
  deltaFields: string[];
  rawData: any[] = [];
  dataRows: any[] = [];
  dummyRow: object;
  prevRow: {};
  editable: boolean = false;
  manualAdd: boolean = true;
  seeMore: boolean = true;
  seeMoreText: boolean = true;
  seeMoreLength: number = 0;
  addAccess: boolean;

  allowExternalData: boolean = false;

  dataPages: Array<object[]> = [];
  pageSize: number = 5;
  currentPage: number = 0;

  cardDepObs: Observable<any> = null;
  cardDepObsSubscription: ISubscription;

  deleteModalConfig: object = {
    cardName: "deleteAddendum",
    // "id": "CL010.8",
    componentId: "addendum",
    type: "addendumNotesListCard",
    required: true,
    editable: true,
    sortOrder: 1,
    data: {
      listHeaders: ["reason"],
    },
    inputs: {
      reason: {
        label: "reasonForDeletingAddendum",
        type: "textarea",
        sortOrder: 1,
        componentId: "addendumDescription",
        rules: {
          minLength: 2,
          rows: 5,
          maxLength: 3000,
          required: true,
        },
      },
    },
    layout: [
      {
        rows: [{ id: "reason" }],
      },
    ],
  };

  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public plt: Platform,
    public translatePipe: TranslateService
  ) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.name = this.config.cardName;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.access = this.config.access;
    this.tooltip = this.config.tooltip;
    this.colHeaders = this.config.data.listHeaders;
    this.conditionalFormatting = this.config.data.conditionalFormatting;
    this.deltaFields = this.config.data.deltaFields || [];
    if (this.config.seeMore) {
      this.seeMore = !this.config.seeMore;
      this.seeMoreLength = this.config.seeMoreLength;
    }

    if (this.config.editable) {
      this.editable = this.config.editable;
    }
    if (this.config.manualAdd !== undefined && this.config.manualAdd !== null) {
      this.manualAdd = this.config.manualAdd;
    }
    if (this.config.allowExternalData) {
      this.allowExternalData = this.config.allowExternalData;
    }

    this.dummyRow = { id: "" };
    let dummyData = {};
    for (let header of this.colHeaders) {
      dummyData[header] = "-";
    }
    this.dummyRow["values"] = dummyData;
  }

  @Input()
  set data(incomingData: any) {
    if (incomingData) {
      this.addAccess = incomingData.addAccess;
      console.log(incomingData);

      // Call some service to load rows and prevRow
      this.dataRows = [];
      if (incomingData.addendums) {
        this.rawData = incomingData.addendums;
        for (let data of incomingData.addendums) {
          let info = {
            id: data.id,
            seemore: this.seeMore,
            seemoretext: this.seeMoreText,
            updateAccess: data.updateAccess,
            deleteAccess: data.deleteAccess,
          };
          let values = this.parseDataRow(data);
          info["values"] = values;
          this.dataRows.push(info);
        }
      }

      this.updateDataPages();

      if (incomingData.previous) {
        let prevData = incomingData.previous;
        let prevInfo = this.parseDataRow(prevData);
        this.prevRow = prevInfo;
      }
    }
  }

  rowHighlighted(col, value) {
    if (this.conditionalFormatting) {
      let formatting = this.conditionalFormatting[col];
      if (formatting) {
        if (
          formatting.type == "greaterThan" &&
          formatting.refValue !== undefined &&
          value > formatting.refValue
        ) {
          return true;
        }
      }
    }

    return false;
  }

  getPageNumber() {
    return this.currentPage + 1;
  }

  presentListForm(data?: object, accept?: Function, reject?: Function): void {
    let config = { config: this.config };
    if (data !== undefined) {
      config["data"] = data;
    }
    let listModal = this.modalCtrl.create("InputModalPage", config, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined && data !== null) {
        this.addData(data);
        if (accept) {
          accept();
        }
      } else if (reject) {
        reject();
      }
    });
    listModal.present();
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      if (typeof data[key] == "object") {
        let innerObj = data[key];
        if (innerObj == undefined) {
          continue;
        }

        if (
          key !== "reportedOn" &&
          key !== "lastReading" &&
          key !== "frequency" &&
          key !== "bereavementCharacteristics"
        ) {
          for (let innerKey of Object.keys(innerObj)) {
            if (key == "leftArmOther" || key == "rightArmOther") {
              let newKey = key;
              flatData[newKey] = innerObj[innerKey];
            } else {
              let newKey =
                key + innerKey.replace(/\b\w/g, (l) => l.toUpperCase());
              flatData[newKey] = innerObj[innerKey];
            }
          }
        } else if (key == "reportedOn" || key == "lastReading") {
          flatData[key] = innerObj["date"] + "T" + innerObj["time"];
        } else if (
          key == "frequency" &&
          innerObj.timeUnit !== undefined &&
          innerObj.timeUnit !== null
        ) {
          // console.log( "Detected frquency input, parsing to string: ", innerObj );
          flatData[key] =
            innerObj.numerator +
            this.translatePipe.instant(" time(s) per ") +
            innerObj.denominator +
            " " +
            this.translatePipe.instant(innerObj.timeUnit);
        } else if (key === "bereavementCharacteristics") {
          let arr = data[key].map((item) => this.translatePipe.instant(item));
          flatData[key] = arr.join(", ");
        }
      } else {
        flatData[key] = data[key];
      }
    }
    return flatData;
  }

  parseDataRow(data: object) {
    let values = {};
    let flatData = this.flattenIncomingData(data);
    for (let header of this.colHeaders) {
      let val = "-";
      if (flatData[header] || flatData[header] === 0) {
        val = flatData[header];
      }
      if (header === "date") {
        val = moment(flatData["createdDte"], "YYYYMMDDTHHmmssZZ").format(
          dateTimeFormat
        );
      } else if (header === "addedBy") {
        val = flatData["statusChangedByName"];
      } else if (header === "role") {
        val = flatData["statusChangedByDiscipline"];
      }
      values[header] = val;
    }
    //add updated date
    let updatedDate = moment(
      flatData["statusChangedDte"],
      "YYYYMMDDTHHmmssZZ"
    ).format(dateTimeFormat);
    if (updatedDate !== values["date"]) {
      values["updatedDate"] = updatedDate;
    }

    return values;
  }

  addData(data: any): void {
    if (data) {
      if (this.assessmentId != null) {
        try {
          this.dataService
            .postAddendum(this.assessmentId, {
              addendumTypeLookupCode: "CL190.1",
              description: data.description,
              signedBy: data.signedBy,
            })
            .subscribe((returnData) => {
              if (!returnData) {
                return;
              }

              let newData = {
                id: returnData.id,
                updateAccess: returnData.updateAccess,
                deleteAccess: returnData.deleteAccess,
                seemore: this.seeMore,
                seemoretext: this.seeMoreText,
              };
              newData["values"] = this.parseDataRow(returnData);
              this.rawData.unshift(returnData);
              this.dataRows.unshift(newData);
              this.updateDataPages();
            });
        } catch (error) {
          //console.log( "Error during data submission and building.", error );
        }
      }
    }
  }

  editRow(row: object): void {
    let modalConfig = { config: this.config };
    let values = this.rawData.filter((record) => record.id == row["id"])[0];
    // B1: the guard was `!== null || !== undefined` (always true), so an id not
    // in rawData left `values` undefined and the field loop below threw. Match
    // the sibling addendum-list-card fix (`&&`).
    if (values !== null && values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData = {};

      for (let key of inputKeys) {
        if (values[key]) {
          if (key === "issueType") {
            values[key] = this.translatePipe.instant(values[key]);
          }
          editData[key] = values[key];
        }
      }
      editData["disclaimerChk"] = ["labelAcknowledge"];
      modalConfig["data"] = editData;
    }

    // console.log( "Launching edit with modal config: ", modalConfig );
    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      // console.log( "GOT DATA BACK!:" );
      // console.log(data);

      if (data !== undefined) {
        this.editData(row, row["id"], data);
      }
    });
    listModal.present();
  }

  editData(oldRow: object, rowId: string, data: any): void {
    // B5: guard on assessmentId (parity with addData) so a null id cannot fire
    // an update against `.../assessments/null/...`.
    if (data && this.assessmentId != null) {
      try {
        this.dataService
          .updateAddendum(rowId, this.assessmentId, {
            addendumTypeLookupCode: "CL190.1",
            description: data.description,
            signedBy: data.signedBy,
          })
          .subscribe((returnData) => {
            let newData = {
              id: returnData.id,
              updateAccess: returnData.updateAccess,
              deleteAccess: returnData.deleteAccess,
              seemore: this.seeMore,
              seemoretext: this.seeMoreText,
            };
            newData["values"] = this.parseDataRow(returnData);
            let rawData = this.rawData;
            for (let index in rawData) {
              if (rawData[index]["id"] === returnData.id) {
                rawData[index] = returnData;
                break;
              }
            }

            this.dataRows.splice(this.dataRows.indexOf(oldRow), 1, newData);
            this.updateDataPages();
          });
      } catch (error) {
        console.log("Error during data submission and building.", error);
      }
    }
  }

  deleteRow(id: string) {
    let deleteModal = this.modalCtrl.create(
      "InputModalPage",
      { config: this.deleteModalConfig },
      { enableBackdropDismiss: false }
    );
    deleteModal.onDidDismiss((data) => {
      if (data !== undefined && data !== null) {
        data["addendumTypeLookupCode"] = "CL190.1";
        this.dataService
          .deleteAddendum(id, this.assessmentId, data)
          .subscribe(() => {
            this.rawData = this.rawData.filter((row) => row.id !== id);
            this.dataRows = this.dataRows.filter((row) => row.id !== id);
            this.updateDataPages();
          });
      }
    });
    deleteModal.present();
  }

  updateDataPages() {
    this.dataPages = [];

    let dataRows = this.dataRows;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (pageIndex > 0) {
      let endingRow = dataRows.length % pageSize;
      if (endingRow > 0) {
        for (let i = endingRow; i < pageSize; i++) {
          dataPages[pageIndex][i] = this.dummyRow;
        }
      }
    }

    // B3: if the list shrank (e.g. after a delete) the current page can point
    // past the last page — clamp it into range. The old comparison against
    // `dataRows.length % pageSize` was meaningless and only stepped back one
    // page, leaving currentPage dangling at an undefined page. Match the
    // sibling addendum-list-card fix.
    if (this.currentPage > this.dataPages.length - 1) {
      this.currentPage = Math.max(0, this.dataPages.length - 1);
    }
  }

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  setPage(page) {
    // B2: `page <= this.dataPages.length` let currentPage land one past the
    // last valid index (an undefined page). Use `<` (sibling parity).
    if (
      page >= 0 &&
      page < this.dataPages.length &&
      page !== this.currentPage
    ) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  lastPage() {
    if (this.currentPage !== this.dataPages.length - 1) {
      this.currentPage = this.dataPages.length - 1;
    }
  }

  ngOnDestroy() {
    if (this.cardDepObsSubscription) {
      this.cardDepObsSubscription.unsubscribe();
      this.cardDepObs = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/add-att-list-card/add-att-list-card.ts